module.exports = __webpack_public_path__ + "static/finley-coloring-book-2-f6b9c777c0c2604593c0be066e993575.jpg";